/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} User_Detail_EventsInputs */



/**
* | output |
* | --- |
* | "Events played ({count})" |
*
* @param {User_Detail_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_detail_events = /** @type {((inputs: User_Detail_EventsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Detail_EventsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Tournois joués (${i?.count})`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Torneos jugados (${i?.count})`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Torneios jogados (${i?.count})`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Tornei giocati (${i?.count})`)
	return /** @type {LocalizedString} */ (`Events played (${i?.count})`)
});